/**
 * Прослушивание событий
 * @param events
 * @param el
 * @param callback
 * @param preventDefault
 */
function listener(events, el, callback, preventDefault) {
	events.split(' ').forEach(event => {
		document.addEventListener(event, function (e) {
			let selectors = document.body.querySelectorAll(Array(el).join(',')),
				element = e.target,
				index = -1;

			while (element && ((index = Array.prototype.indexOf.call(selectors, element)) === -1)) {
				element = element.parentElement;
			}

			if (index > -1) {
				(function () {
					if (typeof callback === "function") {
						setTimeout(() => {
							callback(element, e);
						}, 0);

						if (preventDefault) {
							e.preventDefault();
						}
					}
				}).call(element, e);
			}
		});
	})
}

/**
 * EVENTS
 * @type {{on: eventHandler.on}}
 * Как это работает?
 * Вызов функции: eventHandler.on('элемент который нужно тригернуть', 'как тригернуть элемент');
 */
const eventHandler = {
	on: function (element, event, detail) {
		const eventSuccess = new CustomEvent(event, {
			bubbles: true,
			detail: detail || {}
		});

		element.dispatchEvent(eventSuccess);
	}
}

export {listener, eventHandler}



